import {
  GetCargoClaimCommandInput,
  GetCargoClaimCommand,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function getCargoClaimService(input: GetCargoClaimCommandInput) {
  const token = await getAuthenticationToken();
  if (!token) {
    return null;
  }
  const client = setupClaimIntakeClient(token);
  const command = new GetCargoClaimCommand(input);
  const metricsPublisher = new MetricsPublisher("api.getCargoClaimService");

  return await client
    .send(command)
    .then((response: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
